import React from 'react';
import { Box } from '@mui/material';
import { CustomStyleDropdownPagination } from '../../../../components/Styles';
import TablePagination from '@mui/material/TablePagination';

const CustomTablePagination = ({ rowsPerPage, onRowsPerPageChange, rowsPerPageOptions = [10, 15, 20, 25, 30],labelRowsPerPage='' }) => {

    return (
        <Box sx={CustomStyleDropdownPagination}>
            <TablePagination
                component='div'
                rowsPerPageOptions={rowsPerPageOptions}
                count={''}
                page={''}
                onPageChange={''}
                labelRowsPerPage={labelRowsPerPage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={onRowsPerPageChange}
            />
        </Box>
    );
}

export default CustomTablePagination;
